export default {
    limitInfo: {
        Notification: {
            text: 'Late payments will incur a daily penalty fee based on the overdue amount',
        },
        Message: {
            title: 'Notification',
            text1: 'Overdue credit statement',
            text2: ' days will incur a penalty of ',
            text3: '% of the statement amount',
            buttonText: 'Confirm'
        },
        Alert: {
            error: {
                title: 'Notification',
                text: 'Data request failed. Please try again.',
                buttonText: 'OK'
            }
        },
        Table: {
                headerName: [
                'Credited Merchant',
                'Payment Terms',
                'Reconciliation Date',
                'Penalty Rate',
                'Final Repayment Deadline',
                'Credit Limit',
                'Available Credit',
                'Credit Issued Date',
                'Status'
            ],
            rowScope: {
                text1: 'Statement generated',
                text2: ' days later'
            },
            noData: 'No data available'
        }
    }
}